import { Subject } from "rxjs";
import apiResponse from "../../../../../services/apiResponse";
import DataTableRepository from "../Repositories/DataTableRepository";

class DataTableBloc {
  rowtableChannel = new Subject();
  rapeltableChannel = new Subject();
  revisiExportChannel = new Subject();
  detailBobotChannel = new Subject();
  repository = new DataTableRepository();

  constructor() {
    this.rowtableChannel.next({ status: apiResponse.INITIAL });
    this.rapeltableChannel.next({ status: apiResponse.INITIAL });
    this.revisiExportChannel.next({ status: apiResponse.INITIAL });
    this.detailBobotChannel.next({ status: apiResponse.INITIAL });
  }

  fetchRowTable = async (query, cancelToken) => {
    try {
      this.rowtableChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchRowTable(query, cancelToken)
        .then((result) => {
          this.rowtableChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.rowtableChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("unsubscribed");
    }
  };

  fetchRapelTable = async (query, cancelToken) => {
    try {
      this.rapeltableChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchRapelTable(query, cancelToken)
        .then((result) => {
          this.rapeltableChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.rapeltableChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("unsubscribed");
    }
  };

  fetchRevisiExport = async (query) => {
    try {
      this.revisiExportChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchRevisiExport(query)
        .then((result) => {
          this.revisiExportChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.revisiExportChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {}
  };

  fetchDetailBobot = async (query) => {
    try {
      this.detailBobotChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchDetailBobot(query)
        .then((result) => {
          this.detailBobotChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.detailBobotChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {}
  };
}

export default DataTableBloc;
